import { AnimationFactory } from "../types";

/*
   -------------------------------------------------------
   COLOR PALETTE
   міняй кольори тут і вся анімація зміниться
   -------------------------------------------------------
*/

const TENTACLE_COLORS = {
    body: [40, 120, 70],
    shadow: [20, 70, 40],
    highlight: [120, 255, 170],
    sucker: [170, 255, 170],
    suckerInner: [80, 180, 110],
    tip: [60, 200, 120],
    portal: [80, 200, 120],
    portalDark: [20, 80, 40],
    goo: [160, 255, 160],
};

const rgba = (c: number[], a: number) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;

export const createTentaclesAnimation: AnimationFactory = ({
                                                                        ctx,
                                                                        canvas,
                                                                        startX,
                                                                        startY,
                                                                        endX,
                                                                        endY,
                                                                        startTime,
                                                                        scale
                                                                    }) => {

    const SCALE = scale;

    const flightDuration = 380;
    const portalDuration = 180;
    const grabDuration = 520;

    const totalDuration = flightDuration + portalDuration + grabDuration;

    const attackHalfRange = canvas.width * 0.4;

    const leftBound = Math.max(0, endX - attackHalfRange);
    const rightBound = Math.min(canvas.width, endX + attackHalfRange);

    const lerp = (a:number,b:number,t:number)=>a+(b-a)*t;

    const drawOrb = (x:number,y:number,r:number,a:number)=>{

        const g = ctx.createRadialGradient(x,y,0,x,y,r);

        g.addColorStop(0, rgba(TENTACLE_COLORS.highlight,a));
        g.addColorStop(0.4, rgba(TENTACLE_COLORS.portal,a*0.8));
        g.addColorStop(0.8, rgba(TENTACLE_COLORS.portalDark,a*0.6));
        g.addColorStop(1, "rgba(0,0,0,0)");

        ctx.fillStyle=g;

        ctx.beginPath();
        ctx.arc(x,y,r,0,Math.PI*2);
        ctx.fill();
    };

    const drawPortal=(x:number,y:number,rx:number,ry:number,a:number)=>{

        const g = ctx.createRadialGradient(x,y,0,x,y,Math.max(rx,ry));

        g.addColorStop(0,rgba(TENTACLE_COLORS.portal,a));
        g.addColorStop(0.4,rgba(TENTACLE_COLORS.portalDark,a));
        g.addColorStop(1,"rgba(0,0,0,0)");

        ctx.fillStyle=g;

        ctx.beginPath();
        ctx.ellipse(x,y,rx,ry,0,0,Math.PI*2);
        ctx.fill();

        ctx.strokeStyle = rgba(TENTACLE_COLORS.highlight,a*0.7);
        ctx.lineWidth = 3*SCALE;

        ctx.beginPath();
        ctx.ellipse(x,y,rx*0.85,ry*0.85,0,0,Math.PI*2);
        ctx.stroke();
    };

    const drawSucker=(x:number,y:number,r:number,a:number)=>{

        ctx.fillStyle=rgba(TENTACLE_COLORS.sucker,a);

        ctx.beginPath();
        ctx.arc(x,y,r,0,Math.PI*2);
        ctx.fill();

        ctx.fillStyle=rgba(TENTACLE_COLORS.suckerInner,a*0.8);

        ctx.beginPath();
        ctx.arc(x,y,r*0.45,0,Math.PI*2);
        ctx.fill();
    };

    const drawTentacle=(sx:number,sy:number,ex:number,ey:number,thickness:number,a:number)=>{

        const segments = 16;

        const dx = ex-sx;
        const dy = ey-sy;

        const len = Math.sqrt(dx*dx+dy*dy)||1;

        const nx = -dy/len;
        const ny = dx/len;

        const points:any[]=[];

        for(let i=0;i<=segments;i++){

            const t=i/segments;

            const px = sx + dx*t;
            const py = sy + dy*t;

            const wave =
                Math.sin(t*Math.PI*2+performance.now()*0.01) +
                Math.cos(t*Math.PI*4)*0.4;

            const offset = wave * 20*SCALE * Math.sin(t*Math.PI);

            points.push({
                x:px+nx*offset,
                y:py+ny*offset,
                w:thickness*SCALE*(1-t*0.7),
                t
            });
        }

        ctx.lineCap="round";
        ctx.lineJoin="round";

        for(let i=0;i<points.length-1;i++){

            const p1=points[i];
            const p2=points[i+1];

            ctx.strokeStyle=rgba(TENTACLE_COLORS.shadow,a);
            ctx.lineWidth=p1.w*1.5;

            ctx.beginPath();
            ctx.moveTo(p1.x,p1.y);
            ctx.lineTo(p2.x,p2.y);
            ctx.stroke();

            ctx.strokeStyle=rgba(TENTACLE_COLORS.body,a);
            ctx.lineWidth=p1.w;

            ctx.beginPath();
            ctx.moveTo(p1.x,p1.y);
            ctx.lineTo(p2.x,p2.y);
            ctx.stroke();

            ctx.strokeStyle=rgba(TENTACLE_COLORS.highlight,a*0.4);
            ctx.lineWidth=p1.w*0.25;

            ctx.beginPath();
            ctx.moveTo(p1.x-nx*p1.w*0.15,p1.y-ny*p1.w*0.15);
            ctx.lineTo(p2.x-nx*p2.w*0.15,p2.y-ny*p2.w*0.15);
            ctx.stroke();

            if(i%2===1 && p1.t>0.1 && p1.t<0.85){

                drawSucker(
                    p1.x + nx*p1.w*0.35,
                    p1.y + ny*p1.w*0.35,
                    p1.w*0.13,
                    a
                );
            }
        }

        const tip = points[points.length-1];

        ctx.fillStyle=rgba(TENTACLE_COLORS.tip,a);

        ctx.beginPath();
        ctx.arc(tip.x,tip.y,thickness*SCALE*0.4,0,Math.PI*2);
        ctx.fill();
    };

    return (now:number)=>{

        const elapsed = now-startTime;

        if(elapsed>=totalDuration) return false;

        ctx.clearRect(0,0,canvas.width,canvas.height);

        if(elapsed<flightDuration){

            const t = elapsed/flightDuration;

            const x = lerp(startX,endX,t);
            const y = lerp(startY,endY,t);

            drawOrb(x,y,30*SCALE,0.9);
            drawOrb(x,y,15*SCALE,1);

            ctx.strokeStyle=rgba(TENTACLE_COLORS.portalDark,0.5);
            ctx.lineWidth=20*SCALE;

            ctx.beginPath();
            ctx.moveTo(startX,startY);
            ctx.lineTo(x,y);
            ctx.stroke();

            return true;
        }

        if(elapsed<flightDuration+portalDuration){

            const t = (elapsed-flightDuration)/portalDuration;

            drawPortal(
                endX,
                endY,
                (30+80*t)*SCALE,
                (20+60*t)*SCALE,
                1
            );

            return true;
        }

        const t = (elapsed-flightDuration-portalDuration)/grabDuration;

        drawPortal(
            endX,
            endY,
            (100-20*t)*SCALE,
            (60-10*t)*SCALE,
            0.7
        );

        for(let i=0;i<4;i++){

            const targetX = lerp(leftBound,rightBound,i/3);

            drawTentacle(
                endX,
                endY,
                targetX,
                endY+(Math.random()-0.5)*120*SCALE,
                25,
                1
            );
        }

        for(let i=0;i<10;i++){

            const x = lerp(leftBound,rightBound,Math.random());

            drawTentacle(
                endX,
                endY,
                x,
                endY+(Math.random()-0.5)*200*SCALE,
                10,
                0.8
            );
        }

        return true;
    };
};